import { useEffect, useRef } from "react";

export default function useOuterClick(innerRef, callback) {
  const callbackRef = useRef(); // initialize mutable ref, which stores callback

  // update cb on each render, so second useEffect has access to current value
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    function handleClick(e) {
      if (
        innerRef.current &&
        callbackRef.current &&
        // !innerRef.current.contains(e.target)
        !e.composedPath().includes(innerRef.current)
      )
        callbackRef.current(e, innerRef.current);
    }

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []); // no dependencies -> stable click listener

  // return innerRef; // convenience for client (doesn't need to init ref himself)
}
